import { render, staticRenderFns } from "./WorkerLocationVerification.vue?vue&type=template&id=965a44e0&scoped=true"
import script from "./WorkerLocationVerification.vue?vue&type=script&lang=js"
export * from "./WorkerLocationVerification.vue?vue&type=script&lang=js"
import style0 from "./WorkerLocationVerification.vue?vue&type=style&index=0&id=965a44e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965a44e0",
  null
  
)

export default component.exports